var _rect, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoneTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 10,
    width: 23,
    height: 23,
    fill: "url(#pattern0)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22,
    r: 22,
    fill: "#445FD2",
    fillOpacity: 0.17
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6226_3325",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6226_3325",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAABsElEQVR4nO3aP0oDQRSA8dXCP4X3ERuLmWIu8NoZsPcMKW3Ewi6dZ7AInsB+B0GwsbMTRBTLyERjYSFJZN7M7nw/WEgRyHsfy7LZpOsAAAAAAAAAAAAAFe70Ydf4/tz4/tmE+GZDnB7K7b7OpzcU2YY4syHOfx3T0rO1EHluff9aer7xR16Eji+lZxx/5K/jovScLUSepfeVnnWwRO52jI/Xf0U2Id4ch8e90rMOFpEVEFkBkRUQWQGRFRBZAZEVEFkBkRUQWQGRFRBZAZEVEFkBkRUQWQGRFRBZweAjTybz7a6bb3UVc0P+IfXo5P7Ahnhlff9hfHy3vr+scVA35MjJInLlA7uhR06Xi3Qm1zy4G3rkZejvf0tWuYAbQ+SldE2ucRE3psi1LuQqnGl096ZS0SyjXVAqmEFFyUWllcglF5bWIpdYXFqNrBlAWo+sEUKInD+IEDl/GCFy/kBC5NX8J5QQeT2bBBMib2adcEJknSdsdoxP4bStcrba1r+MlI5tiJw/tiFy/jPbEDl/bEPk/LENkTPd+vn+zIT+KR3pNbdwAAAAAAAAAAAA6H58AgYE66VMLmQ9AAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneTick);
export default __webpack_public_path__ + "static/media/doneTick.83e0668d94530a102c72496938c348d1.svg";
export { ForwardRef as ReactComponent };